import { useStyletron } from 'baseui';
export function ContentContainer({
  children
}) {
  const [css] = useStyletron();
  return <div className={css({
    width: '100%',
    display: 'flex',
    padding: '20px',
    flexDirection: 'column',
    gap: '20px'
  })}>
      {children}
    </div>;
}
export default ContentContainer;